export default "__VITE_ASSET__CwXj_YSb__"